import { css } from '@emotion/react'

export const YoutubeEmbedStyle = css`


  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  margin-bottom: 1rem;
  height: 0;
  

  iframe,.react-loading-skeleton{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

`
